import { render, staticRenderFns } from "./VideoBoostStatistics.vue?vue&type=template&id=4ba8fe6f&scoped=true&"
import script from "./VideoBoostStatistics.vue?vue&type=script&lang=js&"
export * from "./VideoBoostStatistics.vue?vue&type=script&lang=js&"
import style0 from "./VideoBoostStatistics.vue?vue&type=style&index=0&id=4ba8fe6f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ba8fe6f",
  null
  
)

export default component.exports